import Vue from "vue";
import ApiService from "../../services/api";
import moment from "moment";
import { bus } from "../../main";
import { mapGetters } from "vuex";
import helpers from "../../shared/fleetbox-helpers";

export default {
	props: {
		dataItem: Object,
		columns: Array,
		startDate: Object,
		endDate: Object,
		driversSelected: Array,

		filtersByQuery: Boolean,
		debug: Boolean,
		vehicleIdFilterField: String
	},

	data: function() {
		return {
			number_plate: "",
			tripsItems: [],
			totalCount: 0,
			dataReady: false,
			selectedField: "selected",
			hasSelectedMode: true,
			pageSize: 100000,

			jsonRowDataModal: false,
			jsonRowDataModalText: "",
			showCopyMessageSuccessResult: false,
			showCopyMessageErrorResult: false,

			hasAlarmsPermission: false,
			hasDiagnosticPermission: false
		};
	},
	watch: {
		// "dataItem.visible": {
		// 	handler(newValue, oldValue) {
		// 		this.onMasterRowVisibilityChange();
		// 	}
		// }
	},

	created() {
		var self = this;
		//get plates to query for trips detail
		this.number_plate = this.dataItem.number_plate;
		this.getDetailData();

		bus.$on("on-trips-master-visibility-item-change", self.onMasterRowVisibilityChange.bind(self));
		bus.$on(`on-trip-master-row-visibility-item-change-${this.number_plate}`, self.onMasterRowVisibilityChange.bind(self));
		bus.$on("trip-detail-on-selection-row", self.tripDetailOnSelectionRow.bind(self));
		bus.$on("on-marker-click", self.markerClickHandler.bind(self));

		if (this.scopes && this.scopes.length > 0) {
			this.hasAlarmsPermission = this.scopes.some(item => {
				return item == "ALARMS";
			});

			this.hasDiagnosticPermission = this.scopes.some(item => {
				return item == "TRIPS_DIAGNOSTIC_DATA";
			});
		}
	},
	beforeDestroy() {
		bus.$off("on-trips-master-visibility-item-change");
		bus.$off(`on-trip-master-row-visibility-item-change-${this.number_plate}`);
		bus.$off("trip-detail-on-selection-row");
		bus.$off("on-marker-click");
	},
	methods: {
		markerClickHandler(id) {
			if (id) {
				var itemToSelect = this._.find(this.tripsItems, function(x) {
					return x.id === id;
				});

				if (itemToSelect) {
					this.selectRow(itemToSelect);
				}
			}
		},
		tripDetailOnSelectionRow(dataItem) {
			this.tripsItems.forEach(d => {
				if (d.selected && d.id != dataItem.id) {
					Vue.set(d, "selected", undefined);
				}
			});
		},
		selectRow(dataItem) {
			this.tripsItems.forEach(d => {
				if (d.selected) {
					Vue.set(d, "selected", undefined);
				}
			});

			if (!this.isInEditMode && this.hasSelectedMode) {
				//Selected Mode
				Vue.set(dataItem, this.selectedField, !dataItem[this.selectedField]);
				dataItem.id;
				bus.$emit("trip-detail-on-selection-row", dataItem);
			}
		},
		onRowClick: function(e) {
			if (this.hasSelectedMode) {
				this.selectRow(e.dataItem);

				if (e.dataItem.visible) bus.$emit("trip-detail-selected-row", e.dataItem);
			}
		},
		onMasterRowVisibilityChange() {
			var self = this;

			for (var i = 0; i < self.tripsItems.length; i++) {
				self.tripsItems[i].visible = this.dataItem.visible && self.tripsItems[i].privacy_mode == false;
				if (this.dataItem.visible && self.tripsItems[i].privacy_mode == false) {
					bus.$emit("on-trips-show-path", self.tripsItems[i]);
				} else {
					bus.$emit("on-trips-remove-path", self.tripsItems[i]);
				}
			}
		},

		getDetailData() {
			var self = this;

			if (this.dataItem.detailRow) {
				self.tripsItems = self.dataItem.detailRow;

				self.tripsItems.forEach(function(item) {
					if (item.selected) item.selected = false;
				});

				self.totalCount = self.tripsItems.length;

				self.dataReady = true;
			} else {
				var query = {};

				let filterPlatesSelected = [];
				filterPlatesSelected.push(this.number_plate);

				query.sort = "trip_start_date|asc";
				query.plates = filterPlatesSelected;

				if (this.startDate) {
					query["startRange.from"] = moment(this.startDate)
						.utc()
						.format();
				}

				if (this.endDate) {
					query["startRange.to"] = moment(this.endDate)
						.utc()
						.format();
				}

				query["pageSize"] = this.pageSize;

				let driverPlatesSelected = [];
				for (var i = 0; i < this.driversSelected.length; i++) {
					let driverId = this.driversSelected[i];
					driverPlatesSelected.push(driverId);
				}

				if (driverPlatesSelected.length > 0) query.drivers = driverPlatesSelected;

				ApiService.getTripsData(query).then(res => {
					if (res && res.items) {
						self.tripsItems = res.items.map(a => {
							return {
								id: a.id,
								pois: a.associated_pois,
								create_date: a.create_date,
								update_date: a.update_date,
								avg_co2_emission: a.tags.some(tag => tag == "valid_trip_consumption") ? a.avg_co2_emission : "(*)",
								co2_emitted: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.co2_emitted : "(*)",
								avg_fuel_consumption: a.tags.some(tag => tag == "valid_trip_consumption") ? a.interpolated_consumption_lt_hkm : "(*)", //a.avg_fuel_consumption || a.avg_fuel_consumption === 0 ? a.avg_fuel_consumption : "",
								avg_brand_fuel_consumption: a.brand_fuel_consumption, //a.avg_brand_fuel_consumption || a.avg_brand_fuel_consumption === 0 ? a.avg_brand_fuel_consumption : "",
								avg_training_fuel_consumption: "(*)",
								brand_total_lt: a.brand_total_lt,
								fuel_consumption_km_lt: a.tags.some(tag => tag == "valid_trip_consumption") ? a.interpolated_consumption_km_lt : "(*)", //a.avg_training_fuel_consumption || a.avg_training_fuel_consumption === 0 ? a.avg_training_fuel_consumption : "",
								avg_speed: a.tags.some(tag => tag == "no_positions") ? "(*)" : a.avg_speed,
								drive_time: self.$options.filters.timeFromSecondsToString(a.drive_time),
								driver_id: a.driver_id,
								driver_name: a.driver_name,
								mobile_phone_number: a.mobile_phone_number,
								first_start_location: a.start_location,
								first_start_location_display_name: a.start_location_display_name,
								idle_time: self.$options.filters.timeFromSecondsToString(a.idle_time),
								last_end_location: a.end_location,
								last_end_location_display_name: a.end_location_display_name,
								last_known_location: a.last_known_location,
								last_known_location_display_name: a.last_known_location_display_name,
								path: a.path,
								max_speed: a.tags.some(tag => tag == "no_positions") ? "(*)" : a.max_speed,
								number_of_trips: a.number_of_trips,
								number_plate: a.number_plate || self.number_plate,
								//speedometer_final_value: self.$options.filters.mToKm(a.speedometer_final_value),
								//speedometer_initial_value: self.$options.filters.mToKm(a.speedometer_initial_value),
								speedometer_trip_km: self.$options.filters.mToKm(a.speedometer_trip_km),
								gps_trip_km: a.gps_trip_km,
								path_trip_km: a.tags.some(tag => tag == "no_valid_path_km") ? "(*)" : a.path_trip_km,
								interpolated_trip_km: a.tags.some(tag => {
									return tag == "no_valid_interpolated_km";
								})
									? "(*)"
									: a.interpolated_trip_km,
								interpolated_trip_lt: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.interpolated_trip_lt : "(*)",
								path_trip_km_value: a.path_trip_km,
								interpolated_trip_km_value: a.interpolated_trip_km,
								interpolated_trip_lt_value: a.interpolated_trip_lt,
								trip_time: self.$options.filters.timeFromSecondsToString(a.trip_time),
								vehicle_id: a.vehicle_id,
								vehicle_code: a.vehicle_code,
								vehicle_name: a.vehicle_name,
								privacy_mode: a.privacy_mode,
								check: a.check,
								status: a.status,
								// last_odometer_km_value: a.last_odometer_km_value,
								// last_odometer_lt_value: a.last_odometer_lt_value,

								//custom field
								first_trip_start_date: self.$options.filters.dateToString(a.trip_start_date),
								first_trip_start_time: self.$options.filters.timeToString(a.trip_start_date),
								last_trip_end_date: self.$options.filters.dateToString(a.trip_end_date),
								last_trip_end_time: self.$options.filters.timeToString(a.trip_end_date),

								visible: false,
								alarms: false,
								diagnostic: false,
								pois_enabled: false,

								getTripById_ApiRoads: false,

								debugData: self.debug ? JSON.stringify(a, undefined, 2) : null
							};
						});

						this.dataItem["detailRow"] = [];
						for (var i = 0; i < self.tripsItems.length; i++) {
							self.tripsItems[i].visible = self.dataItem.visible && self.tripsItems[i].privacy_mode == false;
							if (this.dataItem.visible && self.tripsItems[i].privacy_mode == false) {
								bus.$emit("on-trips-show-path", self.tripsItems[i]);
							} else {
								bus.$emit("on-trips-remove-path", self.tripsItems[i]);
							}

							this.dataItem.detailRow.push(self.tripsItems[i]);
						}

						self.totalCount = res.totalCount;

						if (self.filtersByQuery && self.$route.query && self.$route.query.vehicleId && self.$route.query.pathId) {
							var numberPlate = self.$route.query.vehicleId;
							var pathId = self.$route.query.pathId;

							var path = self.tripsItems.find(item => {
								return item.id == pathId && item[self.vehicleIdFilterField].toLowerCase() == numberPlate.toLowerCase() && item.privacy_mode == false;
							});

							if (path) {
								self.booleanSwitchChange(path);
								path.visible = true;
							}

							bus.$emit("filter-by-query", false);
						}

						self.setAddress();
					}

					self.dataReady = true;
				});
			}
		},

		setAddress() {
			var self = this;

			var updateServerAddressBulk = function(data) {
				ApiService.setTripPositionDisplayNameBulk(data);
			};

			var bulkGetAddress = function(data, position) {
				if (data.length > 0) {
					ApiService.getBulkReverseGeocoding(data).then(resBulk => {
						if (resBulk && resBulk.length > 0) {
							var dataSetAddress = [];

							for (var i = 0; i < resBulk.length; i++) {
								var resTrip = resBulk[i];
								var itemToUpdate = self.tripsItems.find(item => {
									return item.id == resTrip.id;
								});
								if (itemToUpdate) {
									var res = resTrip.data;
									if (res && res.length > 0) {
										var newAddress = self._.find(res, function(item) {
											return (
												self._.find(item.types, function(x) {
													return x === "streetAddress";
												}) != null
											);
										});

										if (!newAddress) {
											newAddress = res[0];
										}

										var address = "";
										if (newAddress && newAddress.formattedAddress) {
											address = newAddress.formattedAddress;

											dataSetAddress.push({
												id: itemToUpdate.id,
												position: position,
												displayName: address
											});
										}
										itemToUpdate.address = address;

										switch (position) {
											case "start":
												itemToUpdate.first_start_location_display_name = address;
												//updateServerAddress(item.id, position, address);
												break;
											case "end":
												itemToUpdate.last_end_location_display_name = address;
												//updateServerAddress(item.id, position, address);
												break;
											case "lastKnown":
												itemToUpdate.last_known_location_display_name = address;
												//updateServerAddress(item.id, position, address);
												break;
										}
									}
								}
							}

							if (dataSetAddress.length > 0) {
								updateServerAddressBulk(dataSetAddress);
							}
						}
					});
				}
			};

			var indexStart = 1;
			var indexEnd = 1;
			var indexLastKnown = 1;
			var dataGetAddressStart = [];
			var dataGetAddressEnd = [];
			var dataGetAddressLastKnown = [];

			for (var i = 0; i < self.tripsItems.length; i++) {
				var item = self.tripsItems[i];
				//start location
				if ((self._.isNull(item.first_start_location_display_name) || item.first_start_location_display_name.length == 0) && self._.isNull(item.first_start_location) === false) {
					var params = {
						id: item.id,
						latitude: item.first_start_location.lat,
						longitude: item.first_start_location.lon
					};

					dataGetAddressStart.push(params);

					if (indexStart % 25 == 0) {
						bulkGetAddress(dataGetAddressStart, "start");
						dataGetAddressStart = [];
					}

					indexStart++;
					//getAddress(item, "start", params);
				}

				//end location
				if ((self._.isNull(item.last_end_location_display_name) || item.last_end_location_display_name.length == 0) && self._.isNull(item.last_end_location) === false) {
					var params = {
						id: item.id,
						latitude: item.last_end_location.lat,
						longitude: item.last_end_location.lon
					};

					dataGetAddressEnd.push(params);

					if (indexEnd % 25 == 0) {
						bulkGetAddress(dataGetAddressEnd, "end");
						dataGetAddressEnd = [];
					}

					indexEnd++;
					//getAddress(item, "end", params);
				}

				//last know location
				// if ((self._.isNull(item.last_known_location_display_name) || item.last_known_location_display_name.length == 0) && self._.isNull(item.last_known_location) === false) {
				// 	var params = {
				// 		id: item.id,
				// 		latitude: item.last_known_location.lat,
				// 		longitude: item.last_known_location.lon
				// 	};

				// 	dataGetAddressLastKnown.push(params);

				// 	if (indexLastKnown % 25 == 0) {
				// 		bulkGetAddress(dataGetAddressLastKnown, "lastKnown");
				// 		dataGetAddressLastKnown = [];
				// 	}

				// 	indexLastKnown++;
				// 	//getAddress(item, "lastKnown", params);
				// }
			}

			if (dataGetAddressStart.length > 0) {
				bulkGetAddress(dataGetAddressStart, "start");
			}

			if (dataGetAddressEnd.length > 0) {
				bulkGetAddress(dataGetAddressEnd, "end");
			}

			if (dataGetAddressLastKnown.length > 0) {
				bulkGetAddress(dataGetAddressLastKnown, "lastKnown");
			}
		},

		cellClickHandler(e) {},

		showJsonDataModal(jsonData) {
			this.showCopyMessageSuccessResult = false;
			this.showCopyMessageErrorResult = false;
			this.jsonRowDataModalText = jsonData;

			this.$copyText(jsonData);
			this.jsonRowDataModal = true;
		},

		getTripDataByIds(e) {
			var self = this;
			let trip = e.id;
			ApiService.getTripDataById(trip).then(a => {
				if (a) {
					let dataItemTrip = {
						id: a.id,
						pois: a.associated_pois,
						create_date: a.create_date,
						update_date: a.update_date,
						avg_co2_emission: a.tags.some(tag => tag == "valid_trip_consumption") ? a.avg_co2_emission : "(*)",
						avg_fuel_consumption: a.tags.some(tag => {
							return tag == "valid_trip_consumption";
						})
							? a.interpolated_consumption_lt_hkm
							: "(*)",
						avg_brand_fuel_consumption: a.brand_fuel_consumption,
						avg_training_fuel_consumption: "(*)",
						brand_total_lt: a.brand_total_lt,
						fuel_consumption_km_lt: a.tags.some(tag => {
							return tag == "valid_trip_consumption";
						})
							? a.interpolated_consumption_km_lt
							: "(*)",
						avg_speed: a.tags.some(tag => {
							return tag == "no_positions";
						})
							? "(*)"
							: a.avg_speed,
						co2_emitted: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.co2_emitted : "(*)",
						drive_time: self.$options.filters.timeFromSecondsToString(a.drive_time),
						driver_id: a.driver_id,
						driver_name: a.driver_name,
						mobile_phone_number: a.mobile_phone_number,
						first_start_location: a.start_location,
						first_start_location_display_name: a.start_location_display_name,
						idle_time: self.$options.filters.timeFromSecondsToString(a.idle_time),
						last_end_location: a.end_location,
						last_end_location_display_name: a.end_location_display_name,
						last_known_location: a.last_known_location,
						last_known_location_display_name: a.last_known_location_display_name,
						path: a.path,
						max_speed: a.tags.some(tag => {
							return tag == "no_positions";
						})
							? "(*)"
							: a.max_speed,
						number_of_trips: a.number_of_trips,
						number_plate: a.number_plate || self.number_plate,
						speedometer_trip_km: self.$options.filters.mToKm(a.speedometer_trip_km),
						gps_trip_km: a.gps_trip_km,
						path_trip_km: a.tags.some(tag => {
							return tag == "no_valid_path_km";
						})
							? "(*)"
							: a.path_trip_km,
						interpolated_trip_km: a.tags.some(tag => {
							return tag == "no_valid_interpolated_km";
						})
							? "(*)"
							: a.interpolated_trip_km,
						interpolated_trip_lt: a.tags.some(tag => tag == "valid_trip_consumption") || !a.tags.some(tag => tag == "no_valid_lt") ? a.interpolated_trip_lt : "(*)",
						path_trip_km_value: a.path_trip_km,
						interpolated_trip_km_value: a.interpolated_trip_km,
						interpolated_trip_lt_value: a.interpolated_trip_lt,
						trip_time: self.$options.filters.timeFromSecondsToString(a.trip_time),
						vehicle_id: a.vehicle_id,
						vehicle_code: a.vehicle_code,
						vehicle_name: a.vehicle_name,
						privacy_mode: a.privacy_mode,
						check: a.check,
						status: a.status,

						//custom field
						first_trip_start_date: self.$options.filters.dateToString(a.trip_start_date),
						first_trip_start_time: self.$options.filters.timeToString(a.trip_start_date),
						last_trip_end_date: self.$options.filters.dateToString(a.trip_end_date),
						last_trip_end_time: self.$options.filters.timeToString(a.trip_end_date)
					};

					var itemToUpdate = self.tripsItems.find(function(tr) {
						return tr.id == dataItemTrip.id;
					});

					if (itemToUpdate) {
						var dTs = itemToUpdate;

						if (dTs) {
							dTs.pois = dataItemTrip.pois;
							dTs.create_date = dataItemTrip.create_date;
							dTs.update_date = dataItemTrip.update_date;
							dTs.avg_co2_emission = dataItemTrip.avg_co2_emission;
							dTs.avg_fuel_consumption = dataItemTrip.avg_fuel_consumption;
							dTs.avg_brand_fuel_consumption = dataItemTrip.avg_brand_fuel_consumption;
							dTs.avg_training_fuel_consumption = dataItemTrip.avg_training_fuel_consumption;
							dTs.brand_total_lt = dataItemTrip.brand_total_lt;
							dTs.fuel_consumption_km_lt = dataItemTrip.fuel_consumption_km_lt;
							dTs.avg_speed = dataItemTrip.avg_speed;
							dTs.co2_emitted = dataItemTrip.co2_emitted;
							dTs.drive_time = dataItemTrip.drive_time;
							dTs.driver_id = dataItemTrip.driver_id;
							dTs.driver_name = dataItemTrip.driver_name;
							dTs.mobile_phone_number = dataItemTrip.mobile_phone_number;
							dTs.first_start_location = dataItemTrip.first_start_location;
							dTs.first_start_location_display_name = dataItemTrip.first_start_location_display_name;
							dTs.idle_time = dataItemTrip.idle_time;
							dTs.last_end_location = dataItemTrip.last_end_location;
							dTs.last_end_location_display_name = dataItemTrip.last_end_location_display_name;
							dTs.last_known_location = dataItemTrip.last_known_location;
							dTs.last_known_location_display_name = dataItemTrip.last_known_location_display_name;
							dTs.path = dataItemTrip.path;
							dTs.max_speed = dataItemTrip.max_speed;
							dTs.number_of_trips = dataItemTrip.number_of_trips;
							dTs.number_plate = dataItemTrip.number_plate;
							dTs.speedometer_trip_km = dataItemTrip.speedometer_trip_km;
							dTs.gps_trip_km = dataItemTrip.gps_trip_km;
							dTs.path_trip_km = dataItemTrip.path_trip_km;
							dTs.interpolated_trip_km = dataItemTrip.interpolated_trip_km;
							dTs.interpolated_trip_lt = dataItemTrip.interpolated_trip_lt;
							dTs.path_trip_km_value = dataItemTrip.path_trip_km_value;
							dTs.interpolated_trip_km_value = dataItemTrip.interpolated_trip_km_value;
							dTs.interpolated_trip_lt_value = dataItemTrip.interpolated_trip_lt_value;
							dTs.trip_time = dataItemTrip.trip_time;
							dTs.vehicle_id = dataItemTrip.vehicle_id;
							dTs.vehicle_code = dataItemTrip.vehicle_code;
							dTs.vehicle_name = dataItemTrip.vehicle_name;
							dTs.privacy_mode = dataItemTrip.privacy_mode;
							dTs.check = dataItemTrip.check;
							dTs.status = dataItemTrip.status;
							dTs.first_trip_start_date = dataItemTrip.first_trip_start_date;
							dTs.first_trip_start_time = dataItemTrip.first_trip_start_time;
							dTs.last_trip_end_date = dataItemTrip.last_trip_end_date;
							dTs.last_trip_end_time = dataItemTrip.last_trip_end_time;

							dTs.getTripById_ApiRoads = true;
						}

						self.showTrip(dTs);
					}
				}
			});
		},

		showTrip(data) {
			bus.$emit("on-trips-show-path", data);
		},

		booleanSwitchChange(e) {
			if (e) {
				if (!e.visible && e.privacy_mode == false) {
					//get trip to get api roads data, too
					if (e.getTripById_ApiRoads == false) {
						this.getTripDataByIds(e);
					} else {
						this.showTrip(e);
					}
				} else {
					e.alarms = false;
					e.diagnostic = false;
					e.pois_enabled = false;
					bus.$emit("on-trips-remove-path", e);
				}

				this.selectRow(e);

				//check master row visibility
				var self = this;
				this.$nextTick(function() {
					if (self.tripsItems.length > 0) {
						var allOn = self.tripsItems
							.filter(function(item) {
								return item.privacy_mode == false;
							})
							.every(function(item) {
								return item.visible == true;
							});

						self.dataItem.visibility = allOn;
					}
				});
			}
		},

		booleanSwitchAlarmsChange(e) {
			var self = this;
			if (this.hasAlarmsPermission && e) {
				if (!e.alarms && e.privacy_mode == false) {
					if (!e.visible) {
						e.visible = true;

						if (e.getTripById_ApiRoads == false) {
							this.getTripDataByIds(e);
						} else {
							this.showTrip(e);
						}
					}
					var showAlarms = function(data) {
						bus.$emit("on-trips-show-alarms", { dataItem: e, alarmsData: data });
					};

					var query = {};

					// query["dateRange.from"] = moment(this.trip_start_date)
					// 	.startOf("day")
					// 	.utc()
					// 	.format();
					// query["dateRange.to"] = moment(this.trip_end_date)
					// 	.endOf("day")
					// 	.utc()
					// 	.format();

					query["pageSize"] = 1000;
					query["tripId"] = e.id;

					ApiService.getAlarmsData(query).then(res => {
						if (res && res.items) {
							var alarmItems = [];
							alarmItems = res.items.map(a => {
								return {
									id: a.id,
									trip_id: a.trip_id,
									event_date: a.event_date,
									box_serial_number: a.box_serial_number,
									number_plate: a.number_plate,
									vehicle_id: a.vehicle_id,
									vehicle_name: a.vehicle_name,
									vehicle_code: a.vehicle_code,
									driver_id: a.driver_id,
									driver_name: a.driver_name,
									type: a.type,
									subtype: a.subtype,
									position_type: a.position_type,
									type_name: a.type_name,
									description: a.description,
									timestamp: a.timestamp,
									mas: a.mas,
									speed: a.speed,
									position: a.position,
									position_name: a.position_display_name,
									drive_direction: a.drive_direction,
									data: a.data,
									label_name: a.label_name,
									alarm_poi_display_name: a.alarm_poi_display_name,
									data: a.data,

									//custom field
									event_date_date: self.$options.filters.dateToString(a.event_date),
									event_date_time: self.$options.filters.timeToString(a.event_date)
								};
							});

							if (alarmItems.length > 0 && showAlarms) {
								showAlarms(alarmItems);
							}
						}
					});
				} else {
					bus.$emit("on-trips-remove-alarms", e);
				}

				this.selectRow(e);

				//check master row visibility

				this.$nextTick(function() {
					if (self.tripsItems.length > 0) {
						var allOn = self.tripsItems
							.filter(function(item) {
								return item.privacy_mode == false;
							})
							.every(function(item) {
								return item.visible == true;
							});

						self.dataItem.visibility = allOn;
					}
				});

				//e.alarms = !e.alarms;
			}
		},
		booleanSwitchPoisChange(e) {
			var self = this;
			if (e) {
				if (!e.pois_enabled && e.privacy_mode == false && e.pois && e.pois.length > 0) {
					if (!e.visible) {
						e.visible = true;
						if (e.getTripById_ApiRoads == false) {
							this.getTripDataByIds(e);
						} else {
							this.showTrip(e);
						}
					}
					var showPois = function(data) {
						bus.$emit("on-trips-show-pois", { dataItem: e, poisData: data });
					};

					var query = {};
					query["pageSize"] = 1000;

					var poisToQuery = [];
					query["pois"] = e.pois;

					ApiService.getPoiCategoriesData().then(res => {
						let poiCategories = res.map(function(item) {
							return {
								id: item.id,
								name: item.name,
								description: item.description,
								background_color: item.background_color || null,
								icon_image: item.icon_image
							};
						});

						let getPoiDescription = function(poiId) {
							if (poiCategories && poiCategories.length > 0) {
								var poi = poiCategories.find(function(item) {
									return item.id == poiId;
								});

								if (poi) return poi.name;
							}

							return poiId;
						};
						let getPoiFillColor = function(poiId) {
							if (poiCategories && poiCategories.length > 0) {
								var poi = poiCategories.find(function(item) {
									return item.id == poiId;
								});

								if (poi) return poi.background_color;
							}

							return "#000";
						};
						let getPoiIconImgae = function(poiId) {
							if (poiCategories && poiCategories.length > 0) {
								var poi = poiCategories.find(function(item) {
									return item.id == poiId;
								});

								if (poi && poi.icon_image) return poi.icon_image;
								else return "/assets/map/icon/blank.png";
							}

							return null;
						};

						ApiService.getPoisData(query).then(res => {
							var poiItems = res.items.map(function(item) {
								return {
									id: item.id,
									name: item.name,
									poi_category_id: item.poi_category_id,
									poi_category_name: getPoiDescription(item.poi_category_id),
									poi_category_icon_image: getPoiIconImgae(item.poi_category_id),
									poi_category_fill_color: getPoiFillColor(item.poi_category_id),
									radius: item.radius,
									location: item.location,
									value: item.name
								};
							});

							if (poiItems.length > 0 && showPois) {
								showPois(poiItems);
							}
						});
					});
				} else {
					bus.$emit("on-trips-remove-pois", e);
				}

				this.selectRow(e);

				//check master row visibility

				this.$nextTick(function() {
					if (self.tripsItems.length > 0) {
						var allOn = self.tripsItems
							.filter(function(item) {
								return item.privacy_mode == false;
							})
							.every(function(item) {
								return item.visible == true;
							});

						self.dataItem.visibility = allOn;
					}
				});

				//e.alarms = !e.alarms;
			}
		},
		copyJsonRowData() {
			this.showCopyMessageSuccessResult = true;
		},
		booleanSwitchDiagnosticChange(e) {
			if (this.hasDiagnosticPermission && e) {
				if (!e.diagnostic && e.privacy_mode == false) {
					if (!e.visible) {
						e.visible = true;
						if (e.getTripById_ApiRoads == false) {
							this.getTripDataByIds(e);
						} else {
							this.showTrip(e);
						}
					}
					var showDiagnostic = function(data) {
						bus.$emit("on-trips-show-diagnostic", { dataItem: e, diagnosticData: data });
					};

					var query = {};
					query["pageSize"] = 1000;
					query["tripId"] = e.id;
					query["types"] = ["anomaly_event"];

					ApiService.getDiagnosticData(query).then(res => {
						if (res && res.items) {
							var diagnosticItems = [];
							diagnosticItems = res.items.map(a => {
								return {
									id: a.id,
									trip_id: a.trip_id,
									event_date: a.event_date,
									number_plate: a.number_plate,
									vehicle_id: a.vehicle_id,
									vehicle_name: a.vehicle_name,
									vehicle_code: a.vehicle_code,
									driver_id: a.driver_id,
									driver_name: a.driver_name,
									type: a.type,
									subtype: a.subtype,
									icon: a.icon,
									car_gear_position_type: a.car_gear_position_type,
									type_name: a.type_name,
									description: a.description,
									timestamp: a.timestamp,
									mas: a.mas,
									speed: a.speed,
									position: a.position,
									position_name: a.position_display_name,
									drive_direction: a.drive_direction,
									data_category_description: a.data_category_description,
									data: a.data,
									event_date: a.event_date,
									diagnostic_description: a.data && a.data.category_description ? a.data.category_description : "",
									value: a.data && a.data.value ? a.data.value : "",
									um: a.data && a.data.unit ? a.data.unit : ""
								};
							});

							if (diagnosticItems.length > 0 && showDiagnostic) {
								showDiagnostic(diagnosticItems);
							}
						}
					});
				} else {
					bus.$emit("on-trips-remove-diagnostic", e);
				}

				this.selectRow(e);

				//check master row visibility
				var self = this;
				this.$nextTick(function() {
					if (self.tripsItems.length > 0) {
						var allOn = self.tripsItems
							.filter(function(item) {
								return item.privacy_mode == false;
							})
							.every(function(item) {
								return item.visible == true;
							});

						self.dataItem.visibility = allOn;
					}
				});

				//e.diagnostic = !e.diagnostic;
			}
		},
		formattedCoordinates(current_position, typeCoord) {
			if (current_position && current_position.lat && current_position.lon) {
				var tc = typeCoord.substring(0, 3);
				return helpers.formatCoordinate(current_position[tc], tc);
			}
			return null;
		}
	},
	computed: {
		...mapGetters(["scopes"])
	}
};
